import axios from 'util/axiosConfig';


export const fetchTemplatesRequestAPI = async () => {
    return await axios.get(`/api/v1/private-templates`, {
        params: {}
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false };
        });
}

export const addUpdatePrivateTemplateAPI = async (template) => {
    return await axios
        .post(`/api/v1/add-update-private-template`, template)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else if (response === 'Template already exists with the same name or value!') {
                return { success: false, data: 'Template already exists with the same name or value!' };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, 'error': error };
        });
}

export const fetchAllPublicTemplatesRequestAPI = async () => {
    return await axios.get(`/api/v1/public-templates`, {
        params: {}
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false };
        });
}

export const fetchAllCategorizedPublicTemplatesAPI = async () => {
    return await axios.get(`/api/v1/categorized-public-templates`, {
        params: {}
    }).then(function (response) {
        if (response.data) {
            return { success: true, data: response.data };

        } else {
            return { success: false };

        }
    }).catch(function (error) {
        return { success: false }
    })
}


export const deletePrivateTemplateAPI = async (template) => {
    return await axios
        .get(`/api/v1/delete-private-template`, {
            params: {
                templateId: template.id,
                templateName: template.name
            }
        })
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, 'error': error };
        });
}

export const deleteGroupTemplateAPI = async (template) => {
    return await axios
        .get(`/api/v1/delete-group-template`, {
            params: {
                templateId: template.id,
                templateName: template.name
            }
        })
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, 'error': error };
        });
}

export const fetchAllGroupTemplatesAPI = async () => {
    return await axios.get(`/api/v1/group-templates`, {
        params: {}
    }).then(function (response) {
        if (response.data) {
            return { success: true, data: response.data };

        } else {
            return { success: false };

        }
    }).catch(function (error) {
        return { success: false }
    })
}


export const fetchAllCategorizedGroupTemplatesAPI = async () => {
    return await axios.get(`/api/v1/categorized-group-templates`, {
        params: {}
    }).then(function (response) {
        if (response.data) {
            return { success: true, data: response.data };

        } else {
            return { success: false };

        }
    }).catch(function (error) {
        return { success: false }
    })
}

export const addUpdateGroupTemplateAPI = async (template) => {

    return await axios
        .post(`/api/v1/add-update-group-template`, template)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else if (response === 'Template already exists with the same name or value!') {
                return { success: false, data: 'Template already exists with the same name or value!' };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, 'error': error };
        });
}